import { X } from "lucide-react";



const NdrStatusModal = ({ isOpen, setIsOpen, ndrHistory }) => {
  if (!isOpen) return null; // Hide modal if not open
  // console.log("ndrData",ndrData)

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg sm:w-[800px] max-w-full p-5">
        {/* Modal Header */}
        <div className="flex justify-between items-center border-b pb-2">
          <h2 className="text-[14px] font-semibold">NDR Status</h2>
         

<button onClick={() => setIsOpen(false)} className="text-gray-600 hover:text-gray-900">
  <X className="w-4 h-4" />
</button>

        </div>

        {/* Table */}
        <div className="overflow-x-auto mt-4">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-[#0CBB7D] text-white sm:text-[12px] text-[12px]">
                <th className="border-l-[#0CBB7D] border-l-2 px-3 py-1.5">DATE</th>
                <th className="px-3 py-1.5">ACTION</th>
                <th className="px-3 py-1.5">REMARKS</th>
                <th className="border-r-[#0CBB7D] border-r-2 px-3 py-1.5">ATTEMPT</th>
                {/* <th className="border px-4 py-2">BY</th> */}
              </tr>
            </thead>
            <tbody>
              {ndrHistory.length > 0 ? (
                ndrHistory.map((item, index) => (
                  <tr key={index} className="text-center sm:text-[12px] text-xs">
                    <td className="border px-4 py-2">
                      {item.date ? (() => {
                        const d = new Date(new Date(item.date).getTime() - 5.5 * 3600 * 1000);

                        const day = String(d.getDate()).padStart(2, '0');
                        const month = d.toLocaleString('en-US', { month: 'short' });
                        const year = d.getFullYear();

                        let hours = d.getHours();
                        const minutes = String(d.getMinutes()).padStart(2, '0');

                        const amPm = hours < 12 ? 'AM' : 'PM';
                        hours = hours % 12 || 12;
                        const hourStr = String(hours).padStart(2, '0');

                        return `${day}-${month}-${year}, ${hourStr}:${minutes} ${amPm}`;
                      })() : 'N/A'}
                    </td>


                    <td className="border px-4 py-2">{item.action}</td>
                    <td className="border px-4 py-2">{item.remark}</td>
                    <td className="border px-4 py-2">{item.attempt}</td>
                    {/* <td className="border px-4 py-2">{item.by}</td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="border px-3 py-1.5 text-[12px] text-center text-gray-500">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Close Button */}
        <div className="text-right mt-4">
          <button
            onClick={() => setIsOpen(false)}
            className="px-2 py-1.5 bg-gray-500 text-[12px] text-white rounded-md hover:bg-gray-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NdrStatusModal;
